// extracted by mini-css-extract-plugin
module.exports = {"concept-diagram":"index__concept-diagram___n4cBB","conceptDiagram":"index__concept-diagram___n4cBB","adaptive":"index__adaptive___iztaN"};